import './Stepper.eee9983647ae2881d5011949ec1403fa.css';
export default {"controls":"_controls_n5x73_1","back":"_back_n5x73_1","next":"_next_n5x73_1","current":"_current_n5x73_1","leftArrow":"_leftArrow_n5x73_1"};